<template>
  <div>
    <base-loading title="Generando CLABE" v-if="isLoading"></base-loading>
    <v-container
      class="fill-height"
      v-else
      transition="fade-transition"
      ref="downloadSection"
    >
      <v-row align="center" justify="center">
        <v-col xl="5" lg="6" md="7">
          <v-card shaped outlined class="py-5">
            <v-card-title class="justify-center font-weight-bold">
              Pago con SPEI
            </v-card-title>
            <v-card-text class="px-8">
              <div class="text-center mb-4">
                <div class="d-flex align-center justify-center mb-1 mt-4">
                  <span class="text-h4 mb-0 mr-2 black--text">$</span>
                  <span class="text-h2 mb-0 black--text font-weight-regular">{{
                    formatCurrency(amount)
                  }}</span>
                </div>
                <div class="total text-uppercase">Total a pagar</div>

                <div class="mt-4 rounded-border">
                  <div class="text-uppercase text-h6">
                    CLABE: <strong>{{ clabe }}</strong>
                  </div>
                  <div class="text-h6">Banco: <strong>STP</strong></div>
                </div>
              </div>
              <v-alert outlined dense type="info" class="text-body-2">
                <span>
                  Tu pago se verá reflejado un momento después de que realices
                  la transferencia.
                </span>
              </v-alert>
              <div class="text-center">
                <div class="subtitle mt-7 font-weight-bold">Instrucciones</div>
              </div>
              <div class="text-body-1 mt-4">
                <ol>
                  <li>Accede a tu banca en línea o app móvil.</li>
                  <li>Selecciona “Transferencias”.</li>
                  <li>
                    Registra la CLABE interbancaria y selecciona
                    <strong>Finco Pay</strong> ó <strong>STP</strong> como banco
                    remitente.
                  </li>
                  <li>
                    Ingresa el monto a pagar y el concepto de pago (en caso de
                    ser requerido).
                  </li>
                  <li>Confirma la transferencia y guarda tu comprobante.</li>
                </ol>
                <v-btn
                  large
                  depressed
                  rounded
                  block
                  color="primary"
                  class="font-weight-bold mt-7"
                  @click="copyToClipboard"
                >
                  Copiar CLABE
                </v-btn>
                <v-alert
                  v-if="copied"
                  outlined
                  dense
                  color="primary"
                  type="success"
                  class="mt-2 text-body-2"
                >
                  Se ha copiado la CLABE
                </v-alert>
                <v-btn
                  large
                  text
                  rounded
                  block
                  color="primary"
                  class="font-weight-bold mt-5"
                  @click="$router.go(-1)"
                  >Regresar</v-btn
                >
              </div>
            </v-card-text>
          </v-card>
        </v-col> </v-row
      ><img :src="output" />
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { to } from '@/helpers'
import { PaymentService } from '@/api/api.service'
import { pathOr } from '@/helpers/functional'
import { SESSION_ADD_PAYMENT } from '@/store/mutations.type'

export default {
  props: {},
  data() {
    return {
      clabe: null,
      output: null,
      amount: 0,
      isLoading: true,
      copied: false
    }
  },
  computed: {
    ...mapGetters({ user: 'getSessionUser', payment: 'getSessionPayment' })
  },
  mounted() {
    const query = this.$route.query || {}
    const rechargeAmount =
          query.recharge_amount ||
          new URLSearchParams(window.location.search).get('recharge_amount');

    this.getPaymentCLABE(rechargeAmount)
  },
  methods: {
    async getPaymentCLABE(rechargeAmount) {
      this.isLoading = true
      const payload = {}
      const paymentId = this.payment.id
      if (paymentId) {
        payload.payment_id = paymentId
      }

      if (rechargeAmount) {
        payload.recharge_amount = rechargeAmount
      }

      const [err, data] = await to(PaymentService.generatePaymentCLABE(payload))
      if (err) {
        this.isLoading = false
        this.error = this.$t('errors.unknownError')
      } else {
        this.isLoading = false
        const paymentData = pathOr(null, ['data', 'data'], data)
        this.$store.commit(SESSION_ADD_PAYMENT, paymentData)
        this.clabe = paymentData.payment.payment_gateway_id
        this.amount = pathOr([], ['data', 'data', 'payment', 'amount'], data)
      }
      this.isLoading = false
    },
    formatCurrency(value) {
      return this.$options.filters.thousands(value)
    },
    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(`${this.clabe}`)
        this.copied = true
        setTimeout(() => {
          this.copied = false
        }, 2000) // Ocultar el mensaje después de 2 segundos
      } catch (err) {
        console.error('Error al copiar al portapapeles: ', err)
      }
    }
  },
  components: {}
}
</script>
<style lang="scss" scoped>
.v-sheet.v-alert {
  border: 0 !important;
  background-color: rgba(146, 72, 249, 0.1) !important;
  color: #2c3038 !important;
}
.v-alert--text:before {
  background-color: #fff;
}
.subtitle {
  font-size: 1rem;
}
.text-h2 {
  font-size: 3.5rem !important;
}
ol {
  font-size: 0.875rem;
  line-height: 1.45rem;
}
ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}
.rounded-border {
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 16px;
  background-color: #f9f9f9;
}
</style>
